import React, { useEffect, useState } from "react";
import { useAuth } from "components/AuthProvider";
import { useMutation } from "react-query";
import { createCustomerSession } from "api/v2/customerSessions";
import Spinner from "components/spinner";

const Subscriptions: React.FC = () => {
  const { loggedIn, user } = useAuth();
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    createCustomerSessionMutation.mutate();
  }, []);

  const createCustomerSessionMutation = useMutation({
    mutationFn: () => createCustomerSession(),
    onSuccess: async (data) => {
      console.log("Client secret: ", data);
      setClientSecret(data);
    },
    onError: (error) => {
      console.error("Error creating session", error);
    }
  });

  if (!loggedIn) return null;

  if (!clientSecret) {
    return (
      <div className="container">
        <div className="empty">
          <Spinner disabled={false} />
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="container">
        <div className="empty">
          <i className="fas fa-user-times fa-5x"></i>
          <h5>That user was not found.</h5>
        </div>
      </div>
    );
  }
  return (
    <div tw="flex flex-col w-2">
      <div className="mt-4 mb-8">
        <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
        <stripe-pricing-table
          pricing-table-id="prctbl_1RHXIODJpLWtANrYp6umTNse"
          publishable-key="pk_live_BMhFPx5BZzxVy5aZS1uipvtE"
          customer-session-client-secret={clientSecret}
        ></stripe-pricing-table>
      </div>
    </div>
  );
};

export default Subscriptions;
